import { Injectable } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { filter, first, Observable, takeUntil } from "rxjs";
import { SnackBarImp } from "../domain/snack-bar";
import { AlertType, SnackBarModel } from "../domain/snack-bar.model";
import { Failure } from "../../core/domain/failure";

@Injectable({
  providedIn: "root",
})
export class SnackBarService {
  constructor(
    private snackBarImp: SnackBarImp,
    private router: Router,
    private translateService: TranslateService,
  ) {}

  public open(config: SnackBarModel): void {
    this.snackBarImp.open({
      duration: 10000,
      ...config,
    });
  }

  public close(): void {
    this.snackBarImp.close();
  }

  public showSuccess(translationKey: string, closeAfterNavigation = true): void {
    const message: string = this.translateService.instant(translationKey);

    const ref: Observable<void> = this.snackBarImp.open({
      message,
      type: AlertType.success,
      duration: 5000,
    });
    if (closeAfterNavigation) {
      this.router.events
        .pipe(
          filter(e => e instanceof NavigationEnd),
          first(),
          takeUntil(ref),
        )
        .subscribe(() => {
          this.close();
        });
    }
  }

  public showError(failure: Failure | null | undefined | string, closeAfterNavigation = true): void {
    if (!failure) {
      return;
    }

    const message: string = this.translateService.instant(
      typeof failure === 'string' ? failure : failure.message
    );

    const ref: Observable<void> = this.snackBarImp.open({
      message,
      type: AlertType.error,
      withCloseIcon: true,
    });
    if (closeAfterNavigation) {
      this.router.events
        .pipe(
          filter(e => e instanceof NavigationEnd),
          first(),
          takeUntil(ref),
        )
        .subscribe(() => {
          this.close();
        });
    }
  }
}
